/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 13:25:48
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-07-14 11:54:36
 * @Description: file content
 */

import Canvastoimg from "wtc-canvastoimg";

Vue.component("usercard3", {
  props: {
    my_all_info: Object
  },
  template: `
  <div v-if="isShowUserCard&&cardInfo&&cardInfo.ui">
  <div
    v-bind:class="{usercard3:true, animated:true,fadeInDown:isShowAni,fadeOutUp:isHideAni}"
    v-if="isShowMyCard"
  >
    <div class="top">
      <div class="head">
        <img :src="cardInfo.ui.headimg" alt />
      </div>
      <div class="fields">
        <div class="field">
          <span v-if="isInMiniProgram" class="value company">
            <span>{{cardInfo.ui.name}}</span>
          </span>
          <span v-else class="value company company-web">
            <span>{{cardInfo.ui.name}}</span>
          </span>
        </div>
        <div class="field">
          <span class="label">{{cardInfo.ui.company ? cardInfo.ui.company : ''}}</span>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="isShowGuide">
      <div v-for="item in navData" class="item" @click="clickItem(item)">
        <img :src="item.ico" alt />
        <span>{{item.name}}</span>
      </div>
    </div>
    <div class="btn" @click="clickChangeMy" v-if="isShowGuide&&btnChageMyTxt">{{btnChageMyTxt}}</div>
    <div v-if="isMyCard&&isShowMyCard" class="hidecard">
      <img src="http://rs.static.quanc.com.cn/yq-rs-h5/t1/img/eye_hide.png"  @click="clickCardHide" />
    </div>
    <share_guide3 v-if="isShowGuide&&isShowShareGuide" v-on:close="closeShareGuide"></share_guide3>
  </div>
  <div v-if="isMyCard&&!isShowMyCard" class="showcard-container" @click="clickCardShow">
    <div class="showcard">
      <div class="head">
        <img :src="cardInfo.ui.headimg" alt />
      </div>
      <div class="fields">
        <div class="field">
          <span v-if="isInMiniProgram" class="value company">
            <span>{{cardInfo.ui.name}}</span>
          </span>
          <span v-else class="value company company-web">
            <span>{{cardInfo.ui.name}}</span>
          </span>
        </div>
        <div class="field">
          <span class="label">{{cardInfo.ui.company ? cardInfo.ui.company : ''}}</span>
        </div>
      </div>
      <div class="nav-item" :class="index == 0 ? 'nav-item-first' : '' " v-for="(item,index) in hideNavData" :key="index" @click="clickItem(item)">
        <img :src="item.ico" />
      </div>
    </div>
  </div>
  <div v-if="isMyCard&&!isShowMyCard" class="hidecard default_bg" @click="clickCardShow">
    <img src="http://rs.static.quanc.com.cn/yq-rs-h5/t1/img/eye_show.png" />
  </div>
  <vue_showimg v-if="isShowImg" v-bind:img_url="showImgUrl" v-bind:is_show_tips="true" v-on:close="closeShowImg"></vue_showimg>
</div>
  `,
  data() {
    return {
      isShowUserCard: false,
      navData: [
        {
          name: "电话",
          click: "clickCall",
          ico:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/Phone_Mobile.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/Phone_Mobile.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/Phone_Mobile.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "咨询",
          click: "clickChat",
          ico:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/chat.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/chat.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/chat.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "微信",
          click: "clickWx",
          ico:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/wechat.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/wechat.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/wechat.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "分享",
          click: "clickShare",
          ico:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/share.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/share.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/share.png?x-oss-process=image/resize,h_100,w_100"
        }
      ],
      hideNavData: [
        {
          name: "电话",
          click: "clickCall",
          ico:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/Phone_Mobile_white.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/Phone_Mobile_white.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/Phone_Mobile_white.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "咨询",
          click: "clickChat",
          ico:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/chat_white.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/chat_white.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/chat_white.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "分享",
          click: "clickShare",
          ico:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/share_white.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/share_white.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-h5/t1/img/share_white.png?x-oss-process=image/resize,h_100,w_100"
        }
      ],
      btnChageMyTxt: "", //卡片按钮，两种模式：1、编辑 2、换成我的
      isShowHdkShare: false, //是否显示分享
      isShowShareGuide: false, //是否显示网页分享
      isShowImg: false,
      showImgUrl: "",
      isMyCard: false, //是我自己的名片。展示隐藏 展示操作按钮。
      isShowAni: false,
      isHideAni: false,
      // mapStatemapStatemapState
      isInMiniProgram: false,
      isShowMyCard: true,
      isShowGuide: true,
      cardInfo: null,
      userIntegralInfo: null,
      uiVersion: null, // 是否开启新UI 1 开启新UI
      qwQrCodeUrl: '',//企微二维码
      qwQrCodePoster: '',//企微海报
    };
  },
  watch: {
  },
  methods: {
    // 编辑或换成我的
    clickChangeMy() {
      var that = this;
      if (this.btnChageMyTxt == "编辑") {
        // 新版UI员工编辑
        const update = this.updateNewUiList()
        if (update || this.uiVersion == 1) {
          location.href = `${location.protocol}//${location.host}/marketies/${wj.browser.versions.wxwork ? 'qwdesk' : 'desk'}/pages/crm/sale-employee-modeify`;
        } else {
          location.href = location.protocol + "//" + location.host + "/marketies/rc/rs-desk-modifyInfo.html";
        }
      } else if (this.btnChageMyTxt == "换成我的") {
        this.$emit("change-is-me", function (cardInfo) {
          myTemp.rscuid = myTemp.openid;
          that.cardInfo = cardInfo;
          that.setCallAndChat();

          wj.getismp((ismp) => {
            if (ismp) {
              // var shareLink = `${location.protocol}//${location.host}/h5/t1.html?id=${myPageData.PageId}`;
              // if (myTemp.psn) {
              //   shareLink += "&psn=" + myTemp.psn;
              // }
              // shareLink += "&refereeopenid=" + myTemp.openid;
              // shareLink += "&rscuid=" + myTemp.openid;
              // 获取当前连接的参数
              let newUrlParam = wj.getParamFromUrl(location.href);
              // 去掉当前连接的参数j
              if (newUrlParam.j) {
                delete newUrlParam.j;
              }
              // 新增或替换refereeopenid、rscuid为 myTemp.openid
              newUrlParam.refereeopenid = myTemp.openid;
              newUrlParam.rscuid = myTemp.openid;
              // 把参数合并到当前连接
              let newUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(location.href), newUrlParam);
              wj.mp.red(`/pages/webview/common/common?url=${encodeURIComponent(newUrl)}`);
            }
          })
        });
      }
    },
    clickItem(item) {
      this[item.click]();
    },
    // 电话
    clickCall() {
      AddCount(1);
      location.href = "tel:" + this.cardInfo.ui.mobile;
    },
    // 聊天
    clickChat() {
      // 去除点击咨询按钮时的统计
      // AddCount(13);
      // var tmpInterval = setInterval(function () {
      //   if (myTemp.consultingLink) {
      //     var url = myTemp.consultingLink;
      //     if (url.indexOf("chat_room.html") > -1 || url.indexOf("yqim/chat") > -1 || url.indexOf("sale-fans-interaction" > -1)) {
      //       if (myTemp.refereeopenid) {
      //         url += "&refereeopenid=" + myTemp.refereeopenid;
      //       }
      //     } else if (url.indexOf("cus-service.html") > -1) {
      //       // 客服服务已经添加过 refereeopenid 了
      //     }
      //     if (myTemp.rscuid) {
      //       url += "&rscuid=" + myTemp.rscuid;
      //     }
      //     // 在线售楼中心
      //     if (location.href.indexOf("&t9id=") > -1) {
      //       url += "&entry=zxslzx";
      //       url += "&t9id=" + wj.qs("t9id");
      //       url += "&t9psn=" + wj.qs("t9psn");
      //     }
      //     location.href = url;
      //     clearInterval(tmpInterval);
      //   }
      // }, 100)
      let url = myTemp.consultingLink;
      // 在线售楼中心
      if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
        url = wj.addUrlParamFromObj(url, {
          entry: 'zxslzx',
          t9id: myTemp.t9id,
          t9psn: myTemp.t9psn
        })
      }
      if (myTemp.qwQrCodeUrl) {
        url = wj.addUrlParamFromObj(url, {
          qwQrCodeUrl: encodeURIComponent(myTemp.qwQrCodeUrl)
        })
      }
      location.href = url;
    },
    // 微信 isFromCreated 为真的时候只是提前调用下但不弹框
    clickWx(isFromCreated) {
      if (!this.cardInfo) return;
      new Promise((resolve, reject) => {
        if (this.qwQrCodeUrl) {
          resolve();
        } else {
          comreq.getExtUserIdByOpenid({
            openid: this.cardInfo.openid,
            accountType: 'qywx',
            projectid: this.cardInfo.projectid
          }).then(res => {
            if (res.data && (res.data.userid || res.data.account) && res.data.accountOrgid) {
              comreq.getCorpUserCard({
                corpId: res.data.accountOrgid,
                appMark: window.myTemp.appMark,
                type: 1,
                scene: 2,
                style: 1,
                user: [res.data.userid || res.data.account],
                businessData: {
                  sceneCode: "marketing_content"
                },
                projectId: this.cardInfo.projectid
              }).then(res1 => {
                if (res1.data && res1.data.qr_code) {
                  myTemp.qwQrCodeUrl = res1.data.qr_code;
                  $(".qrcodeimg").attr("src", res1.data.qr_code)
                  comreq.base64(res1.data.qr_code).then(resImgUrl => {
                    this.qwQrCodeUrl = resImgUrl;
                    resolve();
                  })
                }
              })
            } else {
              resolve();
            }
          })
        }
      }).then(() => {
        if (this.qwQrCodeUrl) {
          this.navData = this.navData.map(item => {
            if (item.click == "clickWx") {
              item.name = "企微";
              item.ico = "https://assets.rurushishi.com/yq-rs-h5/t1/img/icon_qw.png?x-oss-process=image/resize,h_100,w_100";
              item.no = "https://assets.rurushishi.com/yq-rs-h5/t1/img/icon_qw.png?x-oss-process=image/resize,h_100,w_100";
              item.yes = "https://assets.rurushishi.com/yq-rs-h5/t1/img/icon_qw.png?x-oss-process=image/resize,h_100,w_100";
            }
            return item;
          })
          this.createQwQrCodePoster(isFromCreated)
          // 如果有企微且配置的企微的开关打开了就展示
          if (myPageData.Other && myPageData.Other.funcs && myPageData.Other.funcs.length > 0) {
            myPageData.Other.funcs.forEach(item => {
              if (myTemp.bottomBtnCount < 5) {
                let isAdd = false;
                if (item.isvalid == 1) {
                  if (item.funcType == "qywx" && item.funcName) {
                    $(".btn_wxwork").css("display", "block");
                    isAdd = true;
                  }
                  if (isAdd) {
                    myTemp.bottomBtnCount++;
                  }
                }
              }
            })
          }
        } else if (
          this.cardInfo.wxqr && !isFromCreated
        ) {
          $(".wx-qrcode .text").html("扫码，添加" + this.cardInfo.ui.name + "的微信！");
          $(".wx-qrcode .qr").attr("src", this.cardInfo.wxqr);
          $(".wx-qrcode").removeClass("hide");
        } else if (
          this.cardInfo.ui_weixin && !isFromCreated
        ) {
          alert(`我的微信号是：${this.cardInfo.ui_weixin}`);
        } else if (!isFromCreated) {
          alert("亲，您可以用电话联系我");
        }
      })
    },
    getMaxYData(cvsImgData) {
      let item = null;
      for (let index = 0; index < cvsImgData.length; index++) {
        if (index < cvsImgData.length - 1) {
          if (cvsImgData[index].y < cvsImgData[index + 1].y) {
            item = cvsImgData[index + 1]
          } else {
            item = cvsImgData[index]
          }
        }
      }
      return item;
    },
    createQwQrCodePoster(isFromCreated) {
      if (this.qwQrCodePoster) {
        this.showImgUrl = this.qwQrCodePoster;
        this.isShowImg = true;
        return;
      }
      let bgWidth = 510;
      let bgHeight = 0;//根据文字高度动态计算
      let sharpness = 2;
      let labelX = 30;
      let baseY = 490;
      let lineHeight = 50 * sharpness;
      let cvsImgData = [
        {
          type: "img",
          zIndex: 2,
          x: 0,
          y: 0,
          width: bgWidth * sharpness,
          height: 458 * sharpness,
          content:
            "https://assets.rurushishi.com/yq-rs-h5/qwqrcode_bg2.png",
        },
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 3,
          x: ((bgWidth - 300) / 2) * sharpness,
          y: ((458 - 300) / 2) * sharpness,
          width: 300 * sharpness,
          height: 300 * sharpness,
          content: this.qwQrCodeUrl,
        },
        {
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: baseY * sharpness,
          content: this.cardInfo.name,
          fontSize: `${30 * sharpness}px 微软雅黑`,
          color: "#333333",
        },
        {
          type: "text",
          zIndex: 2,
          x: (labelX + wj.getStrBlen(this.cardInfo.name) * (30 / 2) + 20) * sharpness,
          y: (baseY + 5) * sharpness,
          content: this.cardInfo.mobile,
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#333333",
        },
        {
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: (baseY + 10) * sharpness + lineHeight,
          content: "楼盘项目:",
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#999999",
        },
        {
          type: "text",
          zIndex: 2,
          x: (labelX + wj.getStrBlen("楼盘项目:") * (30 / 2)) * sharpness,
          y: (baseY + 10) * sharpness + lineHeight,
          content: this.cardInfo.projectname,
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#333333",
        }
      ];
      if (this.cardInfo.ui_address) {
        let maxYItem = this.getMaxYData(cvsImgData);
        cvsImgData.push({
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: maxYItem.y + lineHeight,
          content: "地      址:",
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#999999",
        })

        let tmpStrList = [];
        let tmpStrListIndex = 0;
        let title = this.cardInfo.ui_address;

        // title = "一二三四五六七八九十一";
        // title = "一二三四五六七八九十一二三四五六七八九十";
        // title =
        // "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
        for (let index = 0; index < title.length; index++) {
          if (
            tmpStrListIndex == 0 ||
            tmpStrListIndex >= 24 * tmpStrList.length
          ) {
            tmpStrList.push(title[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += title[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += wj.getStrBlen(title[index]);
        }
        let stringYStartValue = maxYItem.y + lineHeight;
        // 最多展示三行
        // if (tmpStrList.length > 3) {
        //   tmpStrList = tmpStrList.slice(0, 3);
        // }
        let stringX = labelX + wj.getStrBlen("一二三四:") * (30 / 2);
        for (let index = 0; index < tmpStrList.length; index++) {

          let stringY = 0;
          if (tmpStrList.length == 1) {
            // stringX =
            //   60 +
            //   (255 - (this.$util.getStrBlen(tmpStrList[index]) / 2) * 14) / 2; //原本的x值+（方框宽度-字符串宽度）/2 居中的写法
            // stringX = 60;
            stringY = stringYStartValue;
          } else {
            // stringX = 60;
            stringY = stringYStartValue + 40 * sharpness * index;
          }
          let item = {
            type: "text",
            zIndex: 4,
            fontSize: `${26 * sharpness}px 微软雅黑`,
            x: stringX * sharpness,
            y: stringY,
            content: tmpStrList[index],
            color: "#333333",
          };
          cvsImgData.push(item);
        }
      }
      if (this.cardInfo.ui_personalprofile) {
        let maxYItem = this.getMaxYData(cvsImgData);
        cvsImgData.push({
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: maxYItem.y + lineHeight,
          content: "个性签名:",
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#999999",
        })

        let tmpStrList = [];
        let tmpStrListIndex = 0;
        let title = this.cardInfo.ui_personalprofile;

        // title = "一二三四五六七八九十一";
        // title = "一二三四五六七八九十一二三四五六七八九十";
        // title =
        // "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
        for (let index = 0; index < title.length; index++) {
          if (
            tmpStrListIndex == 0 ||
            tmpStrListIndex >= 24 * tmpStrList.length
          ) {
            tmpStrList.push(title[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += title[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += wj.getStrBlen(title[index]);
        }
        let stringYStartValue = maxYItem.y + lineHeight;
        // 最多展示三行
        // if (tmpStrList.length > 3) {
        //   tmpStrList = tmpStrList.slice(0, 3);
        // }
        let stringX = labelX + wj.getStrBlen("个性签名:") * (30 / 2);
        for (let index = 0; index < tmpStrList.length; index++) {

          let stringY = 0;
          if (tmpStrList.length == 1) {
            // stringX =
            //   60 +
            //   (255 - (this.$util.getStrBlen(tmpStrList[index]) / 2) * 14) / 2; //原本的x值+（方框宽度-字符串宽度）/2 居中的写法
            // stringX = 60;
            stringY = stringYStartValue;
          } else {
            // stringX = 60;
            stringY = stringYStartValue + 40 * sharpness * index;
          }
          let item = {
            type: "text",
            zIndex: 4,
            fontSize: `${26 * sharpness}px 微软雅黑`,
            x: stringX * sharpness,
            y: stringY,
            content: tmpStrList[index],
            color: "#333333",
          };
          cvsImgData.push(item);
        }
      }
      let maxYItem = this.getMaxYData(cvsImgData);
      bgHeight = maxYItem.y + 60 * sharpness;
      const cvsimg = new Canvastoimg({
        width: bgWidth * sharpness, //画布宽度
        height: bgHeight, //画布高度
        color: "#ffffff", //画布背景色
        data: cvsImgData,
      });
      cvsimg.down().then((canvas) => {
        /* 获取到的是canvas对象 */
        this.qwQrCodePoster = canvas.toDataURL("image/jpg");
        if (!isFromCreated) {
          this.showImgUrl = this.qwQrCodePoster;
          this.isShowImg = true;
        }
      });
    },
    // 分享
    clickShare() {
      this.isShowShareGuide = true;
    },
    // 关闭网页分享引导
    closeShareGuide() {
      this.isShowShareGuide = false;
    },
    // 隐藏卡片
    clickCardHide() {
      this.isShowAni = false;
      this.isHideAni = true;
      var that = this;
      // setTimeout(function () {
      //   that.isShowMyCard = false;
      // }, 500)

      that.isShowMyCard = false;
      myVue.$refs.usercard4.isShowUserCard = false;
      myVue.$refs.usercard4.isShowMyCard = false;
      comreq.updatePageUserSetting(null, 1);
    },
    // 展示卡片
    clickCardShow() {
      this.isHideAni = false;
      this.isShowAni = true;
      var that = this;
      // setTimeout(function () {
      //   that.isShowMyCard = true;
      // }, 500)
      that.isShowMyCard = true;
      myVue.$refs.usercard4.isShowUserCard = true;
      myVue.$refs.usercard4.isShowMyCard = true;
      comreq.updatePageUserSetting(null, 0);
    },
    initCardShowHide() {
      console.log(111, 'myPageData.Other.PageUserSetting', myPageData.Other.PageUserSetting)
      var that = this;
      if (myPageData.Other.PageUserSetting) {
        if (myPageData.Other.PageUserSetting.cardhidden == 0) {
          that.isShowMyCard = true;
        } else if (myPageData.Other.PageUserSetting.cardhidden == 1) {
          that.isShowMyCard = false;
        }
      } else {
        that.isShowMyCard = true;
      }
    },
    setCallAndChat() {
      var that = this;
      if (myTemp.rscuid || (this.my_all_info.userIntegralInfo && this.my_all_info.userIntegralInfo.isSale)) {
        this.isShowUserCard = true;
      }
      if (window.cfg.subdomian == "tyry") {
        this.isShowUserCard = false;
      }

      if (myTemp.rscuid) {
        if (this.my_all_info.userIntegralInfo && this.my_all_info.userIntegralInfo.isSale) {
          if (myTemp.rscuid != myTemp.openid) {
            // 隐藏换成我的
            this.btnChageMyTxt = "";
            // this.btnChageMyTxt = "换成我的";
          } else {
            this.btnChageMyTxt = "";
            // this.btnChageMyTxt = "编辑";
            that.isMyCard = true;
          }
        }
      } else {
        if (this.my_all_info.userIntegralInfo && this.my_all_info.userIntegralInfo.isSale) {
          this.btnChageMyTxt = "";
          // this.btnChageMyTxt = "编辑";
          that.isMyCard = true;
          myTemp.rscuid = myTemp.openid;
        }
      }
      // 致电和聊天换成这个
      if (that.cardInfo && typeof that.cardInfo == "object") {
        if (wj.isMobileNumber(that.cardInfo.ui.mobile)) {
          $(".btn_zd_a").attr("href", "tel:" + that.cardInfo.ui.mobile);
        } else {
          $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
        }
        // if (myTemp.openid != that.cardInfo.openid) {
        //   if (location.host.indexOf('qmyx') > -1) {
        //     myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/desk/pages/fans/sale-fans-interaction?receiveropenid=${that.cardInfo.openid}&projectid=${myPageData.Pid}`;
        //   } else {
        //     myTemp.consultingLink = `${location.protocol}//${location.host}/newcode/src/chat_room.html?openid=${myTemp.openid}&passport=${myTemp.passport}&receiveropenid=${that.cardInfo.openid}&nickname=&pageid=${myPageData.PageId}&projectid=${myPageData.Pid}`;
        //   }
        // }
      }
    },
    // 升级新UI跳转员工修改页面
    updateNewUiList() {
      const newDomain = ['yqjisu', 'sdydfdck', 'qmyx', 'rushi']
      return newDomain.filter(item => location.host.indexOf(item) > -1).length > 0
    },
    checkUiVersion() {
      comreq.getUiVersion().then(res => {
        console.log(res);
        this.uiVersion = res.data
      })
    },
    closeShowImg() {
      this.isShowImg = false;
    }
  },
  created() {
    console.log("cardinfo333", JSON.parse(JSON.stringify(this.my_all_info)));
    console.log(111, 'myPageData', myPageData);
    /**
     * 名片：有rscuid 或 是销售 》展示 名片信息
     * 
     * 名片：有rscuid 且 是销售 且 rscuid不等于自己的openid =》名片信息 展示 换成我的
     * 名片：有rscuid 且 是销售 且 rscuid等于自己的openid =》名片信息 展示 编辑
     * 名片：没有rscuid 且是销售 名片信息 展示编辑
     * 名片：点击换成我的、更改cardInfo信息为自己的信息，初始化分享rscuid是自己的openid
     */

    this.cardInfo = this.my_all_info.fansInfo;
    this.setCallAndChat();
    this.initCardShowHide();
    // 检查是否为新UI
    this.checkUiVersion();
    this.clickWx(true);
    let that = this;
    $(".btn_wxwork").on("click", function () {
      that.clickWx();
    })
  }
});
